import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
// Harden react-hot-toast before anything can call it (see hardenToast.js).
import "utils/hardenToast";
import { Provider } from 'react-redux'; // Import Provider
import store from "redux-store/store";
import "@progress/kendo-theme-default/dist/all.css";
import "assets/theme/components/styles.css";
import App from "App";

import { SoftUIControllerProvider } from "context";

// Multi-tenant Context Provider
import { TenantProvider } from "context/TenantContext";

// App Mode Context Provider
import { AppModeProvider } from "context/AppModeContext";

// Vendor Portal Context Provider
import { VendorProvider } from "context/VendorContext";

// First-run "coach mark" popup provider (see components/CoachMark).
import { UserHintsProvider } from "context/UserHintsContext";

// Global error boundary — catches any unhandled render error and always shows a logout button
import GlobalErrorBoundary from "components/GlobalErrorBoundary";

// Single sign-on (auth/oidc): a page opened with no token first asks Keycloak
// (prompt=none) and renders only if this host isn't on its way there. Password mode,
// or a token already here, renders at once.
import { silentSignInOnStart } from "auth/oidc";
import { hasStoredAuthToken } from "utils/authToken";

const root = ReactDOM.createRoot(document.getElementById("root"));

const renderApp = () => root.render(
  <GlobalErrorBoundary>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <SoftUIControllerProvider>
        <Provider store={store}>
          <TenantProvider>
            <AppModeProvider>
              <VendorProvider>
                <UserHintsProvider>
                  <App />
                </UserHintsProvider>
              </VendorProvider>
            </AppModeProvider>
          </TenantProvider>
        </Provider>
      </SoftUIControllerProvider>
    </BrowserRouter>
  </GlobalErrorBoundary>
);

silentSignInOnStart({ hasToken: hasStoredAuthToken() })
  .catch(() => false)
  .then((leaving) => {
    if (!leaving) renderApp();
  });
